import { SanityEventContent } from '../HolidayLikeALocal.types';
import HolidayLikeALocalCard from '../HolidayLikeALocalCard/HolidayLikeALocalCard';
import './HolidayLikeALocalBody.scss';

interface HolidayLikeALocalBodyProps {
  content: SanityEventContent[];
}

function HolidayLikeALocalBody({ content }: HolidayLikeALocalBodyProps) {
  return (
    <div className="holiday-like-a-local-body">
      <div className="body">
        {content.map((item, index) => (
          <HolidayLikeALocalCard key={index} text={item.text} image={item.image} imageHeader={item.header} />
        ))}
      </div>
    </div>
  );
}
export default HolidayLikeALocalBody;
